import React from 'react'
import {useStyles} from "./CourseCard.css";
import {Card, CardContent, CardMedia, Divider, Grid} from "@mui/material";
import AssociationLogo from "../../../../../commons/utils/logo/AssociationLogo";
import {People, VideoLibrary, Visibility, VisibilityOff} from "@mui/icons-material";
import moment from "moment";
import {FormattedMessage} from "react-intl";

const CourseCard = ({course, headerSize, textSize}) => {
    const classes = useStyles({headerSize: headerSize, textSize: textSize})

    const getDayDifference = () => {
        const fromDate = moment(course.fromDate, 'YYYY-MM-DD')
        const toDate = moment(course.toDate, 'YYYY-MM-DD')
        const diff = Math.round(moment.duration(toDate.diff(fromDate)).asDays())

        return <FormattedMessage id={'app.courses.utils.courseDuration'}
                                 defaultMessage='{n, plural, one {1 day} other {{n} days}}'
                                 values={{n: diff + 1}}/>
    }

    return (
        <Card className={classes.courseCard}>
            <CardMedia>
                <AssociationLogo association={course.association} height={60} width={60}/>
            </CardMedia>
            <CardContent className={classes.courseCardContent}>
                <div className={classes.row}>
                    <div className={classes.courseHeader}>
                        {course.name}
                    </div>
                    <div className={classes.trailingHeaderHow}>
                        <div>
                            {getDayDifference()}
                        </div>
                        <div>
                            {course.open
                                ? <Visibility/>
                                : <VisibilityOff/>}
                        </div>
                    </div>
                </div>
                <Divider orientation={"horizontal"} style={{width: "100%"}}/>
                <div className={classes.courseContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <People className={classes.icon}/>
                        </Grid>
                        <Grid item xs={3}>
                            <b>{course.participants.length}</b>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <VideoLibrary className={classes.icon}/>
                        </Grid>
                        <Grid item xs={3}>
                            <b>{course.playlists.length}</b>
                        </Grid>
                    </Grid>
                </div>
            </CardContent>
        </Card>
    )
}

export default CourseCard
